export const PALLETE_PRIMARY_COLOR = "#191c1f";
export const PALLETE_SECONDARY_COLOR = "#191c1f";
export const BASE_TEXT_COLOR = "#000";
export const BACKGROUND_PRIMARY = "rgba(190, 175, 135,1)";
export const BACKGROUND_SECONDARY = "rgba(0,0,0,0.5)";
export const PRIMARY = "#BEAE89";
